import { Injectable, signal } from '@angular/core';
import { ContentBlockType, FormulaCalloutBlock } from '../../../model';

export const FORMULA_CALLOUT_NODE_NAME = 'formulaCallout';

/** Holds the default formula booklet URL, shared between the editor and node components. */
@Injectable()
export class FormulaBookletUrlService {
  readonly url = signal('');
}

export const DEFAULT_FORMULA_CALLOUT_PROPS = {
  type: ContentBlockType.FormulaCallout,
  formula: { latex_nodes: [] },
  explanation: '',
  show_derivation: false,
  center_formula: true,
  formula_booklet: false,
  formula_booklet_url: '',
  borderless: false,
  content: [],
} as const satisfies Partial<FormulaCalloutBlock>;
